/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earth_Day_2025_Impact_Conclude_BtnInputs */

const en_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awesome!`)
};

const ar_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فخور جدًا`)
};

const de_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So stolz`)
};

const es_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estamos orgullosos`)
};

const fr_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tellement fier(e) !`)
};

const it_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orgoglioso`)
};

const ja_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`素晴らしい`)
};

const ko_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고생했어요`)
};

const pt_br_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que orgulho`)
};

const ru_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Горжусь`)
};

const th_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`น่าภูมิใจมาก`)
};

const tr_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çok gururlu`)
};

const zh_cn_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太棒了`)
};

const zh_tw_earth_day_2025_impact_conclude_btn = /** @type {(inputs: Earth_Day_2025_Impact_Conclude_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太好了！`)
};

/**
* | output |
* | --- |
* | "Awesome!" |
*
* @param {Earth_Day_2025_Impact_Conclude_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_impact_conclude_btn = /** @type {((inputs?: Earth_Day_2025_Impact_Conclude_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Impact_Conclude_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_impact_conclude_btn(inputs)
	if (locale === "ar") return ar_earth_day_2025_impact_conclude_btn(inputs)
	if (locale === "de") return de_earth_day_2025_impact_conclude_btn(inputs)
	if (locale === "es") return es_earth_day_2025_impact_conclude_btn(inputs)
	if (locale === "fr") return fr_earth_day_2025_impact_conclude_btn(inputs)
	if (locale === "it") return it_earth_day_2025_impact_conclude_btn(inputs)
	if (locale === "ja") return ja_earth_day_2025_impact_conclude_btn(inputs)
	if (locale === "ko") return ko_earth_day_2025_impact_conclude_btn(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_impact_conclude_btn(inputs)
	if (locale === "ru") return ru_earth_day_2025_impact_conclude_btn(inputs)
	if (locale === "th") return th_earth_day_2025_impact_conclude_btn(inputs)
	if (locale === "tr") return tr_earth_day_2025_impact_conclude_btn(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_impact_conclude_btn(inputs)
	return zh_tw_earth_day_2025_impact_conclude_btn(inputs)
});